import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { ROUTE_PATHS } from '../shared/constants/route-paths';
import { prefixWithSlash } from '../shared/internal/prefix-with-slash';
import { Policy } from '../shared/models/info/policy';
import { ImportComponent } from './components/pages/dtc/dtc-import/dtc-import.component';
import { DtcOverviewComponent } from './components/pages/dtc/dtc-overview/dtc-overview.component';
import { DtcRecyclingOverviewComponent } from './components/pages/dtc/dtc-recycling-overview/dtc-recycling-overview.component';
import { NewDtcComponent } from './components/pages/dtc/new-dtc/new-dtc.component';
import { ErrorCodeOverviewComponent } from './components/pages/error-code/error-code-overview/error-code-overview.component';
import { ErrorCodeRecyclingOverviewComponent } from './components/pages/error-code/error-code-recycling-overview/error-code-recycling-overview.component';
import { NewErrorCodeComponent } from './components/pages/error-code/new-error-code/new-error-code.component';
import { ErrorMessageOverviewComponent } from './components/pages/error-message/error-message-overview/error-message-overview.component';
import { ErrorMessageRecyclingOverviewComponent } from './components/pages/error-message/error-message-recycling-overview/error-message-recycling-overview.component';
import { NewErrorMessageComponent } from './components/pages/error-message/new-error-message/new-error-message.component';
import { IndexComponent } from './components/pages/index/index.component';
import { InsufficientRightsComponent } from './components/pages/insufficient-rights/insufficient-rights.component';
import { SignInFailedComponent } from './components/pages/sign-in-failed/sign-in-failed.component';
import { SignedOutComponent } from './components/pages/signed-out/signed-out.component';
import { SwPartNumberOverviewComponent } from './components/pages/sw-part-number/sw-part-number-overview/sw-part-number-overview.component';
import { SwPartNumberRecyclingOverviewComponent } from './components/pages/sw-part-number/sw-part-number-recycling-overview/sw-part-number-recycling-overview.component';
import { preventUnsavedChangesGuard } from './guards/prevent-unsaved-changes-guard';
import { policyAccessGuard } from './policy-access.guard';
import { NwNumberOverview } from './components/pages/nw-number/nw-number-overview/nw-number-overview.component';

export const routes: Routes = [
  {
    path: ROUTE_PATHS.index,
    component: IndexComponent,
    canActivate: [MsalGuard, policyAccessGuard(Policy.canRead)],
  },
  {
    path: '',
    redirectTo: prefixWithSlash(ROUTE_PATHS.index),
    pathMatch: 'full',
  },
  {
    path: ROUTE_PATHS.dtcOverview,
    component: DtcOverviewComponent,
    canActivate: [MsalGuard, policyAccessGuard(Policy.canRead)],
    canDeactivate: [preventUnsavedChangesGuard],
  },
  {
    path: 'dtc',
    redirectTo: prefixWithSlash(ROUTE_PATHS.dtcOverview),
    pathMatch: 'full',
  },
  {
    path: ROUTE_PATHS.dtcNew,
    component: NewDtcComponent,
    canActivate: [MsalGuard, policyAccessGuard(Policy.canCreate)],
  },
  {
    path: ROUTE_PATHS.dtcRecycling,
    component: DtcRecyclingOverviewComponent,
    canActivate: [MsalGuard, policyAccessGuard(Policy.canReadSoftDeleted)],
  },
  {
    path: ROUTE_PATHS.errorMessageOverview,
    component: ErrorMessageOverviewComponent,
    canActivate: [MsalGuard, policyAccessGuard(Policy.canRead)],
    canDeactivate: [preventUnsavedChangesGuard],
  },
  {
    path: 'error-message',
    redirectTo: prefixWithSlash(ROUTE_PATHS.errorMessageOverview),
    pathMatch: 'full',
  },
  {
    path: ROUTE_PATHS.errorMessageNew,
    component: NewErrorMessageComponent,
    canActivate: [MsalGuard, policyAccessGuard(Policy.canCreate)],
  },
  {
    path: ROUTE_PATHS.errorMessageRecycling,
    component: ErrorMessageRecyclingOverviewComponent,
    canActivate: [MsalGuard, policyAccessGuard(Policy.canReadSoftDeleted)],
  },
  {
    path: ROUTE_PATHS.nwNumberOverview,
    component: NwNumberOverview,
    canActivate: [MsalGuard, policyAccessGuard(Policy.canRead)],
    canDeactivate: [preventUnsavedChangesGuard],
  },
  {
    path: ROUTE_PATHS.errorCodeOverview,
    component: ErrorCodeOverviewComponent,
    canActivate: [MsalGuard, policyAccessGuard(Policy.canRead)],
    canDeactivate: [preventUnsavedChangesGuard],
  },
  {
    path: 'error-code',
    redirectTo: prefixWithSlash(ROUTE_PATHS.errorCodeOverview),
    pathMatch: 'full',
  },
  {
    path: ROUTE_PATHS.errorCodeRecycling,
    component: ErrorCodeRecyclingOverviewComponent,
    canActivate: [MsalGuard, policyAccessGuard(Policy.canReadSoftDeleted)],
  },
  {
    path: ROUTE_PATHS.errorCodeNew,
    component: NewErrorCodeComponent,
    canActivate: [MsalGuard, policyAccessGuard(Policy.canCreateLegacy)],
  },
  {
    path: ROUTE_PATHS.swPartNumberOverview,
    component: SwPartNumberOverviewComponent,
    canActivate: [MsalGuard, policyAccessGuard(Policy.canRead)],
    canDeactivate: [preventUnsavedChangesGuard],
  },
  {
    path: 'sw-part-number',
    redirectTo: prefixWithSlash(ROUTE_PATHS.swPartNumberOverview),
    pathMatch: 'full',
  },
  {
    path: ROUTE_PATHS.swPartNumberRecycling,
    component: SwPartNumberRecyclingOverviewComponent,
    canActivate: [MsalGuard, policyAccessGuard(Policy.canReadSoftDeleted)],
  },
  {
    path: ROUTE_PATHS.signIn,
    redirectTo: prefixWithSlash(ROUTE_PATHS.index),
    pathMatch: 'full',
  },
  {
    path: ROUTE_PATHS.signedOut,
    component: SignedOutComponent,
  },
  {
    path: ROUTE_PATHS.signInFailed,
    component: SignInFailedComponent,
  },
  {
    path: ROUTE_PATHS.insufficientRights,
    component: InsufficientRightsComponent,
  },
  {
    path: ROUTE_PATHS.import,
    component: ImportComponent,
    canActivate: [MsalGuard, policyAccessGuard(Policy.canImport)],
  },
  {
    path: '**',
    redirectTo: prefixWithSlash(ROUTE_PATHS.index),
    pathMatch: 'full',
  },
];
